import campaignApi from './api/campaignApi';

export const SHORTENLINK_LIST = 'SHORTENLINK/LIST';
export const SHORTENLINK_CLICK_LIST = 'SHORTENLINK/CLICK_LIST';
export const SHORTENLINK_DELETE = 'SHORTENLINK/DELETE';

const initialState = {
  shortenlinks: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHORTENLINK_LIST:
      return {
        ...state,
        shortenlinks: action.payload
      };
    case SHORTENLINK_DELETE:
      return {
        ...state,
        shortenlinks: state.shortenlinks.filter(shortenlink => shortenlink.id !== action.payload)
      };
    default:
      return state;
  }
};

export const shortenLinkList = (userId) => {

  return dispatch => {
    return campaignApi.get(`/link/links/with-count?user=${userId}`).then(data => {
      dispatch({
        type: SHORTENLINK_LIST,
        payload: data
      });
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};

export const shortenLinkClicksList = (shortenKey ,showAll=false) => {

  return dispatch => {
    let requestUrl = `/link/links/clicks/daily/${shortenKey}`;
    if(showAll){
      requestUrl = `/link/links/clicks/daily/${shortenKey}?showAll=${showAll}`;
    }
    return campaignApi.get(requestUrl).then(data => {
      dispatch({
        type: SHORTENLINK_CLICK_LIST,
        payload: data
      });
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};

export const shortenLinkUpdate = (id, payload) => {
  return dispatch => {
    return campaignApi.patch(`/link/${id}`, payload).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};

export const shortenLinkCreate = (payload) => {
  return dispatch => {
    return campaignApi.post(`/link`, payload).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};

export const shortenLinkDelete = (id) => {
  return dispatch => {
    return campaignApi.delete(`/link/${id}`).then(data => {
      dispatch({
        type: SHORTENLINK_DELETE,
        payload: id
      });
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};


export const previewGet = (linkId) => {
  return dispatch => {
    return campaignApi.get(`/preview/${linkId}`).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};

export const previewCreateOrUpdate = (payload) => {
  return dispatch => {
    return campaignApi.post(`/preview`, payload).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};


export const previewUpdate = (linkId, payload) => {
  return dispatch => {
    return campaignApi.patch(`/preview/${linkId}`, payload).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};
